import React from "react";
import { FaLinkedin } from "react-icons/fa";
import { FaGithub } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaFacebookSquare } from "react-icons/fa";
import { FaTwitterSquare } from "react-icons/fa";
import { ReactTyped } from "react-typed";
import { RiContactsLine } from "react-icons/ri";
import { MdAlternateEmail } from "react-icons/md";
import { MdOutlinePlace } from "react-icons/md";
import { LiaBirthdayCakeSolid } from "react-icons/lia";
import { FaDownload } from "react-icons/fa6";
import { NavLink } from "react-router-dom";
import { motion } from "framer-motion";
import leetcode from "./leetcode.svg";
import { duration } from "@mui/material";
import ReactParallaxTilt from "react-parallax-tilt";

const PhotoSection = () => {
  return (
    <ReactParallaxTilt tiltMaxAngleX={3} tiltMaxAngleY={3}>
      <motion.div
        className="sx:min-w-[260px] bg-gradient-to-tr border border-gray-500 via-black to-stone-800 text-white from-gray-800  flex flex-col max-w-[600px] mt-[13vh] relative rounded-lg  max-h-[95vh]"
        initial={{ opacity: 0, x: -100 }}
        animate={{ opacity: 1, x: 0, delay: 0.5 }}
        exit={{ opacity: 0, y: -5000 }}
        transition={{ duration: 0.7 }}
      >
        <ReactParallaxTilt tiltMaxAngleX={15} tiltMaxAngleY={15} className="w-full absolute -top-[13vh] flex justify-center">
          <img
            className="aspect-square w-[200px] rounded-lg border z-50"
            src={process.env.REACT_APP_PROFILE_PHOTO}
          />
        </ReactParallaxTilt>

        <p className="w-full sx:text-xl mt-32 font-bold text-center text-2xl font-poppins">
          Shubham Shinde
        </p>
        <p className="text-xl sx:text-lg font-bold font-barlow text-center">
          <ReactTyped
            strings={["Fullstack Developer"]}
            typeSpeed={200}
            backSpeed={30}
          ></ReactTyped>
        </p>
        <motion.div
          className="text-2xl sx:text-xl flex gap-3 my-2 justify-center items-center"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
        >
          <NavLink to={"https://www.linkedin.com/in/shubham-shinde-1061a8252/"}>
            <FaLinkedin className="hover:scale-125 button hover:shadow-xl cursor-pointer transition-all duration-300" />
          </NavLink>
          <NavLink to={"https://github.com/shubhamshinde6762"}>
            <FaGithub className="hover:scale-125 button hover:shadow-xl cursor-pointer transition-all duration-300" />
          </NavLink>
          <NavLink to={"https://www.codechef.com/users/shubham6710/"}>
            <img
              src="https://avatars.githubusercontent.com/u/11960354?v=4"
              className="hover:scale-125 backdrop-invert w-7 rounded-full border-2 border-yellow-600 p-1 button hover:shadow-xl cursor-pointer transition-all duration-300"
            />
          </NavLink>
          <NavLink to={"https://leetcode.com/shubham6762/"}>
            <img
              src={leetcode}
              className="hover:scale-125 w-7 backdrop-invert rounded-full border-2 border-yellow-600 p-1 button hover:shadow-xl cursor-pointer transition-all duration-300"
            />
          </NavLink>
          <NavLink to={"https://twitter.com/ShindeShubham08"}>
            <FaTwitterSquare className="hover:scale-125 button hover:shadow-xl cursor-pointer transition-all duration-300" />
          </NavLink>
          <NavLink
            to={"https://www.facebook.com/profile.php?id=100027700262061"}
          >
            <FaFacebookSquare className="hover:scale-125 button hover:shadow-xl cursor-pointer transition-all duration-300" />
          </NavLink>
          <NavLink to={"https://www.instagram.com/shubhamshinde08/"}>
            <FaInstagram className="hover:scale-125 button hover:shadow-xl cursor-pointer transition-all duration-300" />
          </NavLink>
        </motion.div>
        <div className="flex flex-col text-sm sx:text-[0.7rem] justify-center items-center border rounded-xl mt-2 p-4 mx-4">
          <div className="w-fit font-bold">
            <div className="flex w-full pl-2 my-2 items-center gap-4">
              <RiContactsLine className="text-xl" />
              <div className="flex flex-col border-l-2 border-black px-2">
                <div className="text-gray-400">Phone</div>
                <div>+91 8412001798</div>
              </div>
            </div>
            <div className="flex w-full pl-2 my-2 items-center gap-4 overflow-hidden">
              <MdAlternateEmail className="text-xl" />
              <div className="flex flex-col border-l-2 border-black px-2">
                <div className="font-bold text-gray-400">Email</div>
                <div className="overflow-ellipsis overflow-clip whitespace-nowrap">
                  shubhamshinde6762@gmail.com
                </div>
              </div>
            </div>
            <div className="flex w-full pl-2 my-2 items-center gap-4">
              <MdOutlinePlace className="text-xl" />
              <div className="flex flex-col border-l-2 border-black px-2">
                <div className="text-gray-400">Location</div>
                <div>Pune, India</div>
              </div>
            </div>
            <div className="flex w-full pl-2 my-2 items-center gap-4">
              <LiaBirthdayCakeSolid className="text-xl" />
              <div className="flex flex-col border-l-2 border-black px-2">
                <div className="text-gray-400">Date of Birth</div>
                <div>
                  17<sup>th</sup> May, 2005
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-center mt-4 mb-4">
          <NavLink
            to={
              process.env.REACT_APP_RESUME
            }
            className="py-2 px-3 sx:text-lg bg-green-600 flex justify-center items-center gap-2 text-xl font-bold text-white rounded-lg hover:scale-105 hover:bg-green-700 transition-all duration-300 cursor-pointer select-none"
          >
            <FaDownload />
            Download CV
          </NavLink>
        </div>
      </motion.div>
    </ReactParallaxTilt>
  );
};

export default PhotoSection;
